import { render, staticRenderFns } from "./CollectionComplaintReport.vue?vue&type=template&id=77fedf74&"
import script from "./CollectionComplaintReport.vue?vue&type=script&lang=js&"
export * from "./CollectionComplaintReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports